import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getConnectionRequests, getHelpRequests, updateIsResolved } from "../Store/Thunk";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import ApiHelper from "../../../../Helpers/ApiHelper";
import { folderEnum } from "../../../../Helpers/EnumHelper";
import HelpRequests from "./Tabs/HelpRequests";
import ConnectionRequests from "./Tabs/ConnectionRequests";

const SuperAdminHelpDesk = () => {
  const dispatch = useDispatch();
  const connectionRequests = useSelector((state) => state.saHelpDesk.connectionRequests);
  const helpRequests = useSelector((state) => state.saHelpDesk.helpRequests);

  const [requestType, setRequestType] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  const getThirtyDaysAgo = () => {
    const pastDate = new Date();
    pastDate.setDate(pastDate.getDate() - 30);
    return pastDate.toISOString().split("T")[0];
  };

  const [startDate, setStartDate] = useState(getThirtyDaysAgo());
  const [endDate, setEndDate] = useState(getTomorrowDate());

  useEffect(() => {
    dispatch(getConnectionRequests({ start: startDate, end: endDate }));
    dispatch(getHelpRequests({ start: startDate, end: endDate }));
  }, [dispatch, startDate, endDate]);

  const SubmitHandler = (e) => {
    e.preventDefault();
    if (requestType === 0) {
      dispatch(getConnectionRequests({ start: startDate, end: endDate }));
    }
    if (requestType === 1) {
      dispatch(getHelpRequests({ start: startDate, end: endDate }));
    }
  };

  const HandleUpdateIsResolved = (id, val) => {
    dispatch(updateIsResolved({ helpReqId: id, isResolved: val })).then(() =>
      dispatch(getHelpRequests({ start: startDate, end: endDate }))
    );
  };

  return (
    <div>
      <Row
        className={"tab-container-single-line text-20 text-color-gray-light fw-semibold mb-3"}
        style={{ height: "40px", margin: "-20px 0 0 0 " }}
      >
        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100  ${requestType === 0 && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => {
              setRequestType(0);
            }}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              connectionRequests ({connectionRequests?.length})
            </Col>
          </Row>
        </Col>

        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100  ${requestType === 1 && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => {
              setRequestType(1);
            }}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              helpRequests ({helpRequests?.length})
            </Col>
          </Row>
        </Col>
      </Row>
      <Form onSubmit={SubmitHandler} style={{ margin: "0px 0 20px 0" }}>
        <Row className="align-items-end">
          <Col xs={12} md={5}>
            <Form.Label>Başlangıç Tarihi</Form.Label>
            <Form.Control type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </Col>
          <Col xs={12} md={5}>
            <Form.Label>Bitiş Tarihi</Form.Label>
            <Form.Control type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </Col>
          <Col xs={12} md={2} className="d-grid">
            <button type="submit" className="btn btn-primary">
              Filtrele
            </button>
          </Col>
        </Row>
      </Form>

      {requestType === 0 && <ConnectionRequests connectionRequests={connectionRequests}></ConnectionRequests>}

      {requestType === 1 && (
        <HelpRequests
          helpRequests={helpRequests}
          HandleUpdateIsResolved={HandleUpdateIsResolved}
          setSelectedImage={setSelectedImage}
        ></HelpRequests>
      )}

      <Modal
        show={selectedImage}
        onHide={() => {
          setSelectedImage(null);
        }}
      >
        <Image src={ApiHelper.cloudFrontURL + folderEnum.help + selectedImage} width={"100%"}></Image>
      </Modal>
    </div>
  );
};
export default SuperAdminHelpDesk;
